import { useQuery } from "@tanstack/react-query";
import { getPaymentHistory } from "../infrastructure/subscription.api";

export function usePaymentHistory(subscriptionId?: string) {
  return useQuery({
    queryKey: ["subscriptions", "payments", subscriptionId],
    queryFn: () => getPaymentHistory(subscriptionId!),
    enabled: !!subscriptionId,
    staleTime: 5 * 60 * 1000,
  });
}
